module.exports = _["merge"];